import React, { useEffect, useState } from 'react'
import { Col, Container, Form, Row, Table } from 'react-bootstrap'
import {
    /*informeComunidadesEnOrganizacion,
    informeComunidadesEnOrganizacionCSV,
    informeComunidadesEnProvincia,
    informeComunidadesEnProvinciaCSV,
    informeEquiposEmail,
    informeEquiposEmailCSV,
    informeEquiposEnProvincia,
    informeEquiposEnProvinciaCSV,
    informeEstudiosCIT,
    informeEstudiosCITCSV,
    informeEstudiosHermanas,
    informeEstudiosHermanasCSV,
    informeHermanasEdad,
    informeHermanasEdadCSV,
    informeHermanasEtapasReligiosas,
    informeHermanasEtapasReligiosasCSV,
    informeHermanasIdentificacion,
    informeHermanasIdentificacionCSV,
    informeHermanasNombre,
    informeHermanasNombreCSV,
    informeLaicosProvincia,
    informeLaicosProvinciaCSV,
    informeNumeroHermanasComunidad,
    informeNumeroHermanasComunidadCSV,
    informeNumeroHermanasProvincia,
    informeNumeroHermanasProvinciaCSV,
    informesCargosComunidades,
    informesCargosComunidadesCSV,
    informesCargosDireccionGeneral,
    informesCargosDireccionGeneralCSV,
    informesCargosProvincias,
    informesCargosProvinciasCSV,
    informesObras,
    informesObrasCSV,
    informesProyectos,
    informesProyectosCSV,
    informeTrabajosLaicos,
    informeTrabajosLaicosCSV,*/

    informeFotosHermanasComunidades,
    informeHermanasAlfabeticoNombre,
    informeHermanasAlfabeticoApellido,
    informeHermanasCumpleanosMeses,
    informeHermanasAlfabeticoApellidoEdadFnac,
    informeHermanasAlfabeticoNombreComunidad,
    informeHermanasAlfabeticoNombreComunidadPaises,
    informeHermanasAlfabeticoNombreCoordinadorasComunidades,
    informeHermanasAlfabeticoNombreCoordinadorasComunidadesCaducan,
    informeHermanasAlfabeticoApellidosRangoEdades,
    informeHermanasAlfabeticoApellidosVotosTemporales,
    informeHermanasAlfabeticoApellidosVotosPerpetuos,
    informeHermanasAlfabeticoApellidosVotosPrenoviciasNovicias,

    informeCounidadesPorProvinciaAlfabético,
    informeCounidadesPorProvinciaPaises,
    informeEquiposComisionesPorProvincia,
    informeMisionAmbito,
    informeMisionAmbitoProyectos,
    informeMisionAmbitoObras,
    informeMisionAmbitoColaboracion,
    informeMisionPorAmbito,
    informeHermanas50aniosCongregación,
    informeHermanas25aniosCongregación,
    informeLaicosWG,


} from '../../reports/informes';
import { Informe } from './informe';

// Custom spinner
import CustomSpinner from "../generic/CustomSpinner";
import { createGlobalStyle } from 'styled-components';

export const InformesMenu = () => {

    // Spinner
    const [loading, setLoading] = useState(false);
    const [filtro, setFiltro] = useState('');

    const tiposInformesProvinciales = [
        {
            nombre: 'Fotos de hermanas por comunidades',

            pdf: informeFotosHermanasComunidades,
        },
        {
            nombre: 'Hermanas por orden alfabético de nombre',
            csv: function () { return informeHermanasAlfabeticoNombre(true) },
            pdf: informeHermanasAlfabeticoNombre,
        },
        {
            nombre: 'Hermanas por orden alfabético de apellido',
            csv: function () { return informeHermanasAlfabeticoApellido(true) },
            pdf: informeHermanasAlfabeticoApellido,
        },
        {
            nombre: 'Hermanas cumpleaños por meses',
            csv: function () { return informeHermanasCumpleanosMeses(true) },
            pdf: informeHermanasCumpleanosMeses,
        },
        {
            nombre: 'Hermanas con edad por orden alfabético de apellido',
            csv: function () { return informeHermanasAlfabeticoApellidoEdadFnac(true) },
            pdf: informeHermanasAlfabeticoApellidoEdadFnac,
        },
        {
            nombre: 'Hermanas por comunidad',
            csv: function () { return informeHermanasAlfabeticoNombreComunidad(true) },
            pdf: informeHermanasAlfabeticoNombreComunidad,
        },
        {
            nombre: 'Hermanas por comunidad por países',
            csv: function () { return informeHermanasAlfabeticoNombreComunidadPaises(true) },
            pdf: informeHermanasAlfabeticoNombreComunidadPaises,
        },
        {
            nombre: 'Hermanas Coordinadoras de comunidades con email y teléfono',
            csv: function () { return informeHermanasAlfabeticoNombreCoordinadorasComunidades(true) },
            pdf: informeHermanasAlfabeticoNombreCoordinadorasComunidades,
        },
        {
            nombre: 'Hermanas Coordinadoras que caducan en el nombramiento en el año actual',
            csv: function () { return informeHermanasAlfabeticoNombreCoordinadorasComunidadesCaducan(true) },
            pdf: informeHermanasAlfabeticoNombreCoordinadorasComunidadesCaducan,
        },
        {
            nombre: 'Hermanas por rango de edades',
            csv: function () { return informeHermanasAlfabeticoApellidosRangoEdades(true) },
            pdf: informeHermanasAlfabeticoApellidosRangoEdades,
        },
        {
            nombre: 'Hermanas de votos temporales',
            csv: function () { return informeHermanasAlfabeticoApellidosVotosTemporales(true) },
            pdf: informeHermanasAlfabeticoApellidosVotosTemporales,
        },
        {
            nombre: 'Hermanas de votos perpetuos',
            csv: function () { return informeHermanasAlfabeticoApellidosVotosPerpetuos(true) },
            pdf: informeHermanasAlfabeticoApellidosVotosPerpetuos,
        },
        {
            nombre: 'Hermanas con votos prenovicias y novicias',
            csv: function () { return informeHermanasAlfabeticoApellidosVotosPrenoviciasNovicias(true) },
            pdf: informeHermanasAlfabeticoApellidosVotosPrenoviciasNovicias,
        },

        {
            nombre: 'Comunidades de la Provincia por orden alafabético',
            csv: function () { return informeCounidadesPorProvinciaAlfabético(true) },
            pdf: informeCounidadesPorProvinciaAlfabético,
        },
        {
            nombre: 'Comunidades de la provincia por países',
            csv: function () { return informeCounidadesPorProvinciaPaises(true) },
            pdf: informeCounidadesPorProvinciaPaises,
        },
        {
            nombre: 'Equipos/comisiones con sus miembros y responsabilidad de cada provincia',
            csv: function () { return informeEquiposComisionesPorProvincia(true) },
            pdf: informeEquiposComisionesPorProvincia,
        },
        {
            nombre: 'Lista misión de la provincia con el ámbito al que pertenecen',
            csv: function () { return informeMisionAmbito(true) },
            pdf: informeMisionAmbito,
        },

        {
            nombre: 'Proyectos STJ de la provincia: nombre, ámbito al que pertenecen, ciudad y país',
            csv: function () { return informeMisionAmbitoProyectos(true) },
            pdf: informeMisionAmbitoProyectos,
        },
        {
            nombre: 'Obras STJ de la provincia: nombre, ámbito al que pertenecen, ciudad y país',
            csv: function () { return informeMisionAmbitoObras(true) },
            pdf: informeMisionAmbitoObras,
        },
        {
            nombre: 'Obras y proyectos en colaboración de la provincia con el ámbito al que pertenecen',
            csv: function () { return informeMisionAmbitoColaboracion(true) },
            pdf: informeMisionAmbitoColaboracion,
        },
        {
            nombre: 'Lista de misión por ámbitos',
            csv: function () { return informeMisionPorAmbito(true) },
            pdf: informeMisionPorAmbito,
        },
        {
            nombre: 'Hermanas que cumplen 25 años de entrada a la Compañía entre los años 2023-2031',
            csv: function () { return informeHermanas25aniosCongregación(true) },
            pdf: informeHermanas25aniosCongregación,
        },
        {
            nombre: 'Hermanas que cumplen 50 años de entrada a la Compañía entre los años 2023-2031',
            csv: function () { return informeHermanas50aniosCongregación(true) },
            pdf: informeHermanas50aniosCongregación,
        },
        {
            nombre: 'Laicos/as miembros de equipos/comisiones de la provincia, por equipo/comisión y su email',
            csv: function () { return informeLaicosWG(true) },
            pdf: informeLaicosWG,
        },
    ]

    const tiposInformes = [{}]
    /*
        {
            nombre: 'Número de hermanas por provincia',
            csv: informeNumeroHermanasProvinciaCSV,
            pdf: informeNumeroHermanasProvincia,
        }, {
            nombre: 'Número de hermanas por comunidad',
            csv: informeNumeroHermanasComunidadCSV,
            pdf: informeNumeroHermanasComunidad,
        }, {
            nombre: 'Comunidades en cada provincia',
            csv: informeComunidadesEnProvinciaCSV,
            pdf: informeComunidadesEnProvincia,
        }, {
            nombre: 'Comunidades en STJ',
            csv: informeComunidadesEnOrganizacionCSV,
            pdf: informeComunidadesEnOrganizacion,
        }, {
            nombre: 'Listado de hermanas',
            csv: informeHermanasNombreCSV,
            pdf: informeHermanasNombre,
        }, {
            nombre: 'Listado de hermanas y edad',
            csv: informeHermanasEdadCSV,
            pdf: informeHermanasEdad,
        }, {
            nombre: 'Listado de hermanas y etapas religiosas',
            csv: informeHermanasEtapasReligiosasCSV,
            pdf: informeHermanasEtapasReligiosas,
        }, {
            nombre: 'Estudios de las hermanas',
            csv: informeEstudiosHermanasCSV,
            pdf: informeEstudiosHermanas,
        }, {
            nombre: 'Identificación de las hermanas',
            csv: informeHermanasIdentificacionCSV,
            pdf: informeHermanasIdentificacion,
        }, {
            nombre: 'Trabajo de los laicos',
            csv: informeTrabajosLaicosCSV,
            pdf: informeTrabajosLaicos,
        }, {
            nombre: 'Hermanas con el curso CIT',
            csv: informeEstudiosCITCSV,
            pdf: informeEstudiosCIT,
        }, {
            nombre: "Equipos/comisiones en cada provincia",
            csv: informeEquiposEnProvinciaCSV,
            pdf: informeEquiposEnProvincia,
        }, {
            nombre: "Equipos/comisiones en cada provincia con email",
            csv: informeEquiposEmailCSV,
            pdf: informeEquiposEmail,
        }, {
            nombre: "Laicos por provincia",
            csv: informeLaicosProvinciaCSV,
            pdf: informeLaicosProvincia,
        }, {
            nombre: "Proyectos actuales STJ",
            csv: informesProyectosCSV,
            pdf: informesProyectos,
        }, {
            nombre: "Obras actuales STJ",
            csv: informesObrasCSV,
            pdf: informesObras
        }, {
            nombre: "Cargos en dirección general que caducan este año",
            csv: informesCargosDireccionGeneralCSV,
            pdf: informesCargosDireccionGeneral,
        }, {
            nombre: "Cargos en provincias que caducan este año",
            csv: informesCargosProvinciasCSV,
            pdf: informesCargosProvincias,
        }, {
            nombre: "Cargos en comunidades que caducan este año",
            csv: informesCargosComunidadesCSV,
            pdf: informesCargosComunidades,
        }

        
    ];
*/
    const spinner = (activo) => {
        setLoading(activo)
    }

    /*
        setInformesProvinciales(tiposInformesProvinciales.filter((tipo) => {
            const filtro = event.target.value;
            return tipo.nombre.toLowerCase().indexOf(filtro.toLowerCase()) !== -1;
        }));
    */

    return (
        <>
            <CustomSpinner animation={"border"} loading={loading} />
            <Container>
                {
                    // Buscador
                }
                <Row>
                    <Col lg={12} className="d-flex justify-content-xl-center my-3">
                        <Form
                            className="w-75"
                            onSubmit={(e) => {
                                e.preventDefault();
                            }}
                        >
                            <Form.Control type="text" placeholder="Busque su informe"
                                name="busqueda" autoComplete="off" onChange={(e) => setFiltro(e.target.value)} />
                        </Form>
                    </Col>
                </Row>
            </Container>

            <Container sm="true">
                <Table hover bordered>
                    <thead>
                        <tr>
                            <th>Informes Provinciales</th>
                            <th>Exportación a XLSX</th>
                            <th>Exportación a PDF</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            tiposInformesProvinciales
                                .filter((informe) =>
                                    informe.nombre.toLowerCase().includes(filtro)
                                )
                                .map((tiposInformesProvincial) => <Informe key={tiposInformesProvincial.nombre} spinner={spinner} {...tiposInformesProvincial} />)
                        }
                    </tbody>
                </Table>
                {/*
                <Table>
                    <thead>
                        <tr>
                            <th>Informe</th>
                            <th>Exportación a CSV</th>
                            <th>Exportación a PDF</th>
                        </tr>
                    </thead>
                    <tbody>
                        {informes.map((tipoInforme) => <Informe key={tipoInforme.nombre} spinner={spinner} {...tipoInforme} xlsx={false} />)}
                    </tbody>

                    
                </Table>
                */}
            </Container>

        </>
    )
}
